import * as actionTypes from "./actionTypes";

const licenseInitialState = {
  processing: false,
  loadingLicense: false,
  license: null,
  uniqueId: null,
  activeModules: null,
  deactivatedModules: null,
  allowedModules: null,
  otherModules: null,
  loadingLicenseHistory: false,
  licenseHistory: null,
  modules: null,
};

export const licenseReducer = (state = licenseInitialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.RESET_LICENSE:
      return licenseInitialState;
    case actionTypes.LOAD_LICENSE:
      return { ...state, loadingLicense: true };
    case actionTypes.SET_PROCESSING:
      return { ...state, processing: true };
    case actionTypes.GET_LICENSE:
      const modules = payload?.modules.filter(
        (module) => module.isAllowed === true
      );

      const activated = payload?.modules.filter(
        (module) => module.isAllowed === true && module.isActive === true
      );

      const decactivated = payload?.modules.filter(
        (module) => module.isAllowed === true && module.isActive === false
      );

      let otherModules = payload?.modules.filter(
        (module) => module.isAllowed === false
      );

      if (state.modules?.length > payload?.modules?.length) {
        const index =
          state.modules?.length -
          (state.modules?.length - payload?.modules?.length);

        const additionalModules = state.modules?.slice(index);

        otherModules = [
          ...otherModules,
          ...additionalModules?.map((m) => ({
            module: m,
            isAllowed: false,
            isActive: false,
          })),
        ];
      }

      return {
        ...state,
        license: payload,
        uniqueId: payload?.uniqueId,
        activeModules: activated,
        deactivatedModules: decactivated,
        allowedModules: modules,
        otherModules: otherModules,
        loadingLicense: false,
      };
    case actionTypes.UPDATE_BANK_LICENSE:
      return { ...state, processing: false };
    case actionTypes.CHANGE_BANK_LICENSE:
      return { ...state, processing: false };
    case actionTypes.CUSTOMIZE_MODULES:
      return { ...state, processing: false };
    case actionTypes.LOAD_LICENSE_HISTORY:
      return {
        ...state,
        loadingLicenseHistory: payload,
      };
    case actionTypes.GET_LICENSE_HISTORY:
      return {
        ...state,
        loadingLicenseHistory: false,
        licenseHistory: payload,
      };
    case actionTypes.GET_MODULES:
      return {
        ...state,
        modules: payload,
      };
    default:
      return state;
  }
};
